export default __webpack_public_path__ + "82b3822e943fdffc799552815d40198e.svg";